import React from 'react'
import PropTypes from 'prop-types'
import { Content } from './style'

const Message = ({ type = 'error', children = '', align = 'right' }) => {
  return (
    <>{children && <Content type={type} align={align}>{children}</Content>}</>
  )
}

Message.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
  align: PropTypes.string
}

export default Message
